var map = {
	"./01.jpg": 370,
	"./02.jpg": 371,
	"./03.jpg": 372,
	"./04.jpg": 373,
	"./05.jpg": 374,
	"./06.jpg": 375,
	"./07.jpg": 376,
	"./08.jpg": 377,
	"./09.jpg": 378,
	"./10.jpg": 379,
	"./11.jpg": 380,
	"./12.jpg": 381,
	"./13.jpg": 382,
	"./14.jpg": 383,
	"./15.jpg": 384,
	"./16.jpg": 385,
	"./17.jpg": 386,
	"./18.jpg": 387,
	"./19.jpg": 388,
	"./20.jpg": 389,
	"./21.jpg": 390,
	"./22.jpg": 391,
	"./23.jpg": 392,
	"./24.jpg": 393,
	"./25.jpg": 394,
	"./26.jpg": 395,
	"./27.jpg": 396,
	"./28.jpg": 397,
	"./29.jpg": 398,
	"./30.jpg": 399,
	"./31.jpg": 400,
	"./32.jpg": 401,
	"./33.jpg": 402,
	"./34.jpg": 403,
	"./35.jpg": 404,
	"./36.jpg": 405,
	"./37.jpg": 406,
	"./38.jpg": 407,
	"./39.jpg": 408,
	"./40.jpg": 409,
	"./41.jpg": 410,
	"./42.jpg": 411,
	"./43.jpg": 412,
	"./44.jpg": 413,
	"./45.jpg": 414,
	"./46.jpg": 415,
	"./47.jpg": 416,
	"./48.jpg": 417,
	"./49.jpg": 418,
	"./51.jpg": 419,
	"./52.jpg": 420,
	"./53.jpg": 421,
	"./54.jpg": 422,
	"./55.jpg": 423,
	"./56.jpg": 424,
	"./57.jpg": 425,
	"./58.jpg": 426,
	"./59.jpg": 427,
	"./60.jpg": 428
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray nonrecursive \.(png|jpe?g|svg)$
// module id = 369
// module chunks = 0